module.exports = __webpack_public_path__ + "static/media/key.47d405ca.webp";